import { fetchJson } from 'utils/fetch';

export const fetchSettings = () => fetchJson('/catalog/settings.json');

export const fetchTemplates = () => fetchJson('/catalog/templates.json');

export const fetchPlatforms = () => fetchJson('/catalog/platforms.json');



// WEBPACK FOOTER //
// ./src/modules/catalog/api/index.js